import { render, staticRenderFns } from "./WishlistOverview.vue?vue&type=template&id=32d25418&scoped=true&"
import script from "./WishlistOverview.vue?vue&type=script&lang=js&"
export * from "./WishlistOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d25418",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32d25418')) {
      api.createRecord('32d25418', component.options)
    } else {
      api.reload('32d25418', component.options)
    }
    module.hot.accept("./WishlistOverview.vue?vue&type=template&id=32d25418&scoped=true&", function () {
      api.rerender('32d25418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/WishlistOverview.vue"
export default component.exports